import React, { Fragment, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Formik, FieldArray, Field } from 'formik';
import * as Yup from 'yup';
import { makeStyles, Typography, Card, CardContent } from '@material-ui/core';
import { grey } from '@material-ui/core/colors';
import Button from '@material-ui/core/Button';
import { useHistory } from 'react-router';
import axios from 'axios';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import Select from '@material-ui/core/Select';
import './styles.css';
import { CommonConfig } from '../../../config/common-config';
import LoaderPopUp from '../../../components/loaderpopup/loader';
import SuccessPopUp from '../../../components/loaderpopup/success';
import ErrorPopUp from '../../../components/loaderpopup/error';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import clsx from 'clsx';

function StyledRadio(props) {
    const classes = useStyles();

    return (
        <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            {...props}
        />
    );
}

const useStyles = makeStyles((theme) => ({
    padding: {
        marginTop: '24px',
        textAlign: 'center',
        color: grey[700],
    },
    addButton: {
        float: 'right',
        borderRadius: '0px',
        width: '55px',
        height: '40px',
        border: 'none',
    },
    displayEngagement: {
        display: 'none',
    },
    bottomLine: {
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
    },
    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        marginTop: '0px',
        '& li': {
            display: 'inline-block',
            padding: '10px 0',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
}));
const UpdateIndInvoice = () => {
    const history = useHistory();
    const [showBtnLoader, setShowBtnLoader] = useState(false);
    const [clientId, setClientId] = useState('');
    const [buyerEmailid, setBuyerEmailId] = useState('');
    const [apiData, setApiData] = useState([]);
    const tennantName = useSelector((state) => state.loginsuccessreducer.tennantName.tennantName);
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const [count, setCount] = useState(0);
    const [length, setLength] = useState(0);
    const [successpop, setSuccessPop] = useState(false);
    const [errorpop, setErrorPop] = useState(false);
    const [errorMsgGenerateRecceipt, setErrorMsgGenerateRecceipt] = useState('');

    const initialValues1 = {
        data: [
            {
                name: '',
                hsn: '',
                tax: '',
                amount: '',
                description: '',
            },
        ],
        Igst: '18',
        Cgst: '0',
        Sgst: '0',
        description: '',
        isIGST: 'IGST',
    };
    const [initialValues, setInitialValues] = useState(initialValues1);
    const [particularData, setParticularData] = useState(initialValues);
    const [serviceId, setServiceId] = useState('');

    const validationSchema = Yup.object().shape({
        data: Yup.array().of(
            Yup.object().shape({
                name: Yup.string().nullable().required('Required Field'),
                hsn: Yup.string()
                    .nullable()
                    .matches(/^[0-9\,]+$/, 'Please enter digits only')
                    // .matches(/^(\d{6})?(\d{8})?$/, 'Enter 6 or 8 digit HSN')
                    .required('Required Field'),

                tax: Yup.string().nullable().ensure().required('Required Field'),
                amount: Yup.string()
                    .matches(/^[0-9\,]+$/, 'Please enter digits only')
                    .required('Please Fill the Amount'),
            })
        ),
        engagementRefNo: Yup.string()
            .nullable()
            .matches(/^[a-zA-Z0-9]*$/, 'Enter a valid Engagement Reference No.'),
        Igst: Yup.string()
            .nullable()
            .when('isIGST', {
                is: 'IGST',
                then: Yup.string()
                    .nullable()
                    .matches(/^[0-9\,.]+$/, 'Please enter digits only')
                    .required('Required Field'),
            }),
        Cgst: Yup.string()
            .nullable()
            .when('isIGST', {
                is: 'CGST / SGST',
                then: Yup.string()
                    .nullable()
                    .matches(/^[0-9\,.]+$/, 'Please enter digits only')
                    .required('Required Field'),
            }),
        Sgst: Yup.string()
            .nullable()
            .when('isIGST', {
                is: 'CGST / SGST',
                then: Yup.string()
                    .nullable()
                    .matches(/^[0-9\,.]+$/, 'Please enter digits only')
                    .required('Required Field'),
            }),
        isIGST: Yup.string().nullable(),

        // description: Yup.string().required('Required Field'),
    });

    function numberWithCommas(x) {
        // console.log('aaaaa')
        x = x.toString();
        const IndianCur = new Intl.NumberFormat('en-IN').format(parseFloat(x.replace(/,/g, '')));
        return IndianCur;
    }

    useEffect(() => {
        let tennantNm = '';
        let clientId1 = '';
        if (history.location && history.location.state && history.location.state.row) {
            let serviceId = history.location.state.row.serviceId;
            setServiceId(serviceId);
            if (history.location.state.buyer_type === 'Individual') {
                clientId1 = history.location.state.row.iclientId;
                setClientId(history.location.state.row.iclientId);
            } else if (history.location.state.buyer_type === 'Corporate') {
                clientId1 = history.location.state.row.corpclientId;
                setClientId(history.location.state.row.corpclientId);
            }
            const axiosConfig = {
                headers: {
                    Authorization: bearerToken,
                },
            };
            // const apiUrl = `${CommonConfig.dev.baseUrl}/api/auth/admingenerate-invoice/${tennantName}`;
            const apiUrlGenInvoiceOnServId = `${CommonConfig.dev.baseUrl}/api/auth/admingenerate-invoice-itr/${serviceId}/${tennantName}`;

            axios
                .post(apiUrlGenInvoiceOnServId, '', axiosConfig)
                .then((res) => {
                    setApiData(res.data);
                    //console.log('SERVICE ID???', res.data.Particulars);
                    if (res.data.Particulars) {
                        let tempArr = [];
                        res.data.Particulars.filter((ele, i) => {
                            let temp = {
                                name: ele.particularsText,
                                hsn: ele.hsnSac,
                                tax: ele.isTaxable === true ? 'yes' : 'no',
                                amount: numberWithCommas(ele.amount),
                                description: ele.description,
                            };
                            tempArr.push(temp);
                        });
                        const pArrApi = {
                            data: tempArr,
                            Igst: '18',
                            Cgst: '0',
                            Sgst: '0',
                            description: '',
                            isIGST: 'IGST',
                        };
                        //console.log('pArrApi', pArrApi);
                        setInitialValues(pArrApi);
                        setBuyerEmailId();
                    }
                })
                .catch((error) => { });
        } else if (history.location && history.location.state && history.location.state.clientId) {
            setClientId(history.location.state.clientId);
        }

        if (history.location && history.location.state && history.location.state.clientData) {
            const pData = history.location.state.clientData;
            let particularArr = history.location.state.clientData.particulars;
            history.location.state.clientData.reimbursement.filter((value) => {
                particularArr.push(value);
                return true;
            });
            particularArr = particularArr.reduce((unique, o) => {
                if (!unique.some((obj) => obj.name === o.name && obj.amount === o.amount && obj.hsn === o.hsn && obj.tax === o.tax)) {
                    unique.push(o);
                }
                return unique;
            }, []);
            //console.log(particularArr);
            setCount(particularArr.length - 1);
            setLength(particularArr.length);
            initialValues.data = particularArr;
            initialValues.description = pData.description;
            initialValues.isIGST = pData.isIGST;
            initialValues.Igst = pData.igst;
            initialValues.Cgst = pData.cgst;
            initialValues.Sgst = pData.sgst;
            setParticularData(initialValues);
            setApiData(history.location.state.apiData);
        }
    }, [tennantName, userToken]);

    const classes = useStyles();
    const handleClose = () => {
        setShowBtnLoader(false);
    };
    const handleClick = () => {
        setCount(count + 1);
    };

    const handleRemove = () => {
        setCount(count - 1);
    };

    //append comma for amount textfield
    const handleStateChange = (e) => {
        const {
            target: { value },
        } = e;
        if (value.length && !isNaN(parseFloat(value))) {
            const IndianCur = new Intl.NumberFormat('en-IN').format(parseFloat(value.replace(/,/g, '')));
            e.target.value = IndianCur;
            //console.log("Indian Currency", e.target.value);
        } else {
            e.target.value = value;
        }
    };
    // const handleStateChange = (e) => {
    //     const {
    //         target: { value },
    //     } = e;
    //     if (value && !isNaN(parseFloat(value))) {
    //         e.target.value = parseInt(value.replace(/,/g, '')).toLocaleString();
    //     }
    // };

    const handleSubmit = (values) => {
        setShowBtnLoader(true);

        const pArr = [];
        const rArr = [];
        let subTotal1 = 0;
        let total = 0;

        values.data.map((val, index) => {
            if (val.tax === 'yes') {
                const apArr = {
                    name: val.name,
                    hsn: val.hsn,
                    tax: val.tax,
                    amount: val.amount,
                    description: val.description,
                };
                pArr.push(apArr);
                val.amount = val.amount.replace(/\,/g, '');
                subTotal1 = parseInt(subTotal1, 10) + parseInt(val.amount, 10);
                setTimeout(() => {
                    setShowBtnLoader(false);
                    // setSuccessPop(true);
                }, 1500);
                // setTimeout(() => {
                //     history.push('/menu/taxInvoice');
                // }, 3000);
            } else if (val.tax === 'no') {
                const arArr = {
                    name: val.name,
                    hsn: val.hsn,
                    tax: val.tax,
                    amount: val.amount,
                    description: val.description,
                };
                rArr.push(arArr);
                //console.log('208', arArr)
                val.amount = val.amount.replace(/\,/g, '');
                total = parseInt(total, 10) + parseInt(val.amount, 10);
                setTimeout(() => {
                    setShowBtnLoader(false);
                    // setSuccessPop(true);
                }, 1500);
                // setTimeout(() => {
                //     history.push('/menu/taxInvoice');
                // }, 3000);
            }
            return true;
        });
        const igstAmount = parseFloat((subTotal1 * values.Igst) / 100);
        const cgstAmount = parseFloat((subTotal1 * values.Cgst) / 100);
        const sgstAmount = parseFloat((subTotal1 * values.Sgst) / 100);
        const subTotal2 = parseFloat(igstAmount + cgstAmount + sgstAmount);
        total = total + subTotal1 + subTotal2;
        total = Math.round(total);

        const clientData = {
            igst: values.Igst,
            cgst: values.Cgst,
            sgst: values.Sgst,
            igst_amount: igstAmount,
            cgst_amonut: cgstAmount,
            sgst_amount: sgstAmount,
            tax_amount: igstAmount + cgstAmount + sgstAmount,
            sub_total1: subTotal1,
            sub_total2: subTotal2,
            total,
            description: values.description,
            buyer_type: history.location.state.buyer_type
                ? history.location.state.buyer_type
                : history.location.state.clientData.buyer_type,
            tennant_name: tennantName,
            isIGST: values.isIGST,
            // buyer_Email:data.invoiceUATForEmail.buyerEmail
        };

        clientData.particulars = pArr;
        clientData.reimbursement = rArr;
        //console.log('clientDataclientData', clientData)

        history.push({
            pathname: '/menu/taxInvoiceInd',
            // clientData,
            // clientId,
            // apiData,
            state: { clientId, clientData, apiData },
        });
    };

    const handleGSTChange = (val, formik) => {
        //console.log('valval', val)
        if (val && val === 'IGST') {
            formik.values.Sgst = '0';
            formik.values.Cgst = '0';
            formik.values.Igst = '18';
        }
        if (val && val === 'CGST / SGST') {
            formik.values.Sgst = '9';
            formik.values.Cgst = '9';
            formik.values.Igst = '0';
        }
    };

    return (
        <div>
            {successpop ? (
                <SuccessPopUp open={successpop} showSuccess={successpop} handleClose={handleClose} title="Invoice generated successfully" />
            ) : null}
            {errorpop ? (
                <ErrorPopUp open={errorpop} showError={errorpop} handleClose={handleClose} title={errorMsgGenerateRecceipt} />
            ) : null}

            <Card className="client-card">
                <CardContent className="client-heading">
                    {length > 0 ? (
                        <Typography variant="h5" component="h1">
                            Update Generate Invoice Details
                        </Typography>
                    ) : (
                            <Typography variant="h5" component="h1">
                                Generate Invoice Details
                        </Typography>
                        )}
                </CardContent>
                <CardContent>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={(values) => handleSubmit(values)}
                        enableReinitialize
                    >
                        {(formik) => {
                            return (
                                <div>
                                    <form className="itecform" onSubmit={formik.handleSubmit}>
                                        <div className="itecform-textboxdiv">
                                            <FieldArray name="data">
                                                {(fieldArrayProps) => {
                                                    const { push, form, remove } = fieldArrayProps;
                                                    const { values } = form;
                                                    const { data } = values;
                                                    let key = 0;
                                                    return (
                                                        <>
                                                            {data.map((item, index) => {
                                                                key++;
                                                                return (
                                                                    <Fragment key={key}>
                                                                        {/* {index > 0 && (
                                                                            <div className="field-divider">
                                                                                <hr />
                                                                            </div>
                                                                        )} */}
                                                                        <Card className="w100 mb15">
                                                                            <Grid container spacing={3} className="main-container">
                                                                                <Grid item xs={12} sm={12}>
                                                                                    <FormControl fullWidth>
                                                                                        <InputLabel
                                                                                            className="lbl"
                                                                                            htmlFor="Enter Particulars"
                                                                                            shrink
                                                                                        >
                                                                                            {' '}
                                                                                            Particulars
                                                                                            <span style={{ color: '#ff0a047a' }}>*</span>
                                                                                        </InputLabel>
                                                                                        <Field name={`data[${index}].name`}>
                                                                                            {(fieldProps) => {
                                                                                                //console.log(fieldProps, 'Field Props');
                                                                                                const { field, meta } = fieldProps;
                                                                                                // const { touched, errors } = form;
                                                                                                return (
                                                                                                    <>
                                                                                                        <Input
                                                                                                            // name={`name${index}`}
                                                                                                            // name="name"
                                                                                                            type="text"
                                                                                                            className="bottom"
                                                                                                            placeholder="Enter Particulars"
                                                                                                            {...field}
                                                                                                        />

                                                                                                        {meta.touched && meta.error ? (
                                                                                                            <span className="itec-validationError">
                                                                                                                {meta.error}
                                                                                                            </span>
                                                                                                        ) : null}
                                                                                                    </>
                                                                                                );
                                                                                            }}
                                                                                        </Field>
                                                                                    </FormControl>
                                                                                </Grid>

                                                                                <Grid item xs={12} sm={6}>
                                                                                    <FormControl fullWidth>
                                                                                        <InputLabel
                                                                                            className="lbl"
                                                                                            htmlFor="Enter HSN/SAC"
                                                                                            shrink
                                                                                        >
                                                                                            {' '}
                                                                                            Enter HSN/SAC
                                                                                            <span style={{ color: '#ff0a047a' }}>*</span>
                                                                                        </InputLabel>
                                                                                        <Field name={`data[${index}].hsn`}>
                                                                                            {(fieldProps) => {
                                                                                                const { field, meta } = fieldProps;
                                                                                                return (
                                                                                                    <>
                                                                                                        <Input
                                                                                                            type="text"
                                                                                                            className="bottom"
                                                                                                            placeholder="HSN/SAC"
                                                                                                            {...field}
                                                                                                        />

                                                                                                        {meta.touched && meta.error ? (
                                                                                                            <span className="itec-validationError">
                                                                                                                {meta.error}
                                                                                                            </span>
                                                                                                        ) : null}
                                                                                                    </>
                                                                                                );
                                                                                            }}
                                                                                        </Field>
                                                                                    </FormControl>
                                                                                </Grid>
                                                                                {/* <Grid item xs={12} sm={6}>
                                                                    <FormControl fullWidth>
                                                                    <InputLabel className="lbl" htmlFor="Engagement Reference no" shrink>Engagement Reference No
                                                                    </InputLabel>
                                                                    <Field name={`data[${index}].engagementRefNo`}>
                                                                        {(fieldProps) => {
                                                                            const { field, meta } = fieldProps;
                                                                            // const { touched, errors } = form;
                                                                            return (
                                                                                <>
                                                                                    <Input
                                                                                        // name={`name${index}`}
                                                                                        // name="name"
                                                                                        type="text"
                                                                                        className="bottom"
                                                                                        placeholder="Engagement Reference no"
                                                                                        {...field}
                                                                                    />

                                                                                    {meta.touched && meta.error ? (
                                                                                        <span className="itec-validationError">
                                                                                            {meta.error}
                                                                                        </span>
                                                                                    ) : null}
                                                                                </>
                                                                            );
                                                                        }}
                                                                    </Field>
                                                                
                                                                </FormControl>
                                                                </Grid> */}
                                                                                <Grid item xs={12} sm={6}>
                                                                                    <FormControl fullWidth>
                                                                                        <InputLabel
                                                                                            className="lbl"
                                                                                            htmlFor="Enter Amount"
                                                                                            shrink
                                                                                        >
                                                                                            {' '}
                                                                                            Enter Amount
                                                                                            <span style={{ color: '#ff0a047a' }}>*</span>
                                                                                        </InputLabel>
                                                                                        <Field name={`data[${index}].amount`}>
                                                                                            {(fieldProps) => {
                                                                                                const { field, meta } = fieldProps;
                                                                                                return (
                                                                                                    <>
                                                                                                        <Input
                                                                                                            className="bottom "
                                                                                                            placeholder="Amount"
                                                                                                            onInput={(e) =>
                                                                                                                handleStateChange(e)
                                                                                                            }
                                                                                                            {...field}
                                                                                                        />

                                                                                                        {meta.touched && meta.error ? (
                                                                                                            <span className="itec-validationError">
                                                                                                                {meta.error}
                                                                                                            </span>
                                                                                                        ) : null}
                                                                                                    </>
                                                                                                );
                                                                                            }}
                                                                                        </Field>
                                                                                    </FormControl>
                                                                                </Grid>
                                                                                <Grid item xs={12} sm={6}>
                                                                                    <FormControl fullWidth>
                                                                                        <InputLabel
                                                                                            className="lbl"
                                                                                            htmlFor="Enter Tax Inclusion"
                                                                                            shrink
                                                                                        >
                                                                                            Tax Inclusion
                                                                                            <span style={{ color: '#ff0a047a' }}>*</span>
                                                                                        </InputLabel>
                                                                                        <Field name={`data[${index}].tax`}>
                                                                                            {(fieldProps) => {
                                                                                                const { field, meta } = fieldProps;
                                                                                                return (
                                                                                                    <>
                                                                                                        <Select
                                                                                                            native
                                                                                                            className="bottom "
                                                                                                            placeholder="Tax Inclusion"
                                                                                                            {...field}
                                                                                                        >
                                                                                                            <option value="">
                                                                                                                Tax Options
                                                                                                            </option>
                                                                                                            <option value="yes">Yes</option>
                                                                                                            <option value="no">No</option>
                                                                                                        </Select>

                                                                                                        {meta.touched && meta.error ? (
                                                                                                            <span className="itec-validationError">
                                                                                                                {meta.error}
                                                                                                            </span>
                                                                                                        ) : null}
                                                                                                    </>
                                                                                                );
                                                                                            }}
                                                                                        </Field>
                                                                                    </FormControl>
                                                                                </Grid>
                                                                                <Grid item xs={12} sm={6}>
                                                                                    <FormControl fullWidth>
                                                                                        <InputLabel
                                                                                            className="lbl"
                                                                                            htmlFor="Enter Description"
                                                                                            shrink
                                                                                        >
                                                                                            {' '}
                                                                                            Description
                                                                                        </InputLabel>
                                                                                        <Field name={`data[${index}].description`}>
                                                                                            {(fieldProps) => {
                                                                                                const { field, meta } = fieldProps;
                                                                                                // const { touched, errors } = form;
                                                                                                return (
                                                                                                    <>
                                                                                                        <Input
                                                                                                            className="bottom "
                                                                                                            placeholder="Enter Description"
                                                                                                            {...field}
                                                                                                        />

                                                                                                        {meta.touched && meta.error ? (
                                                                                                            <span className="itec-validationError">
                                                                                                                {meta.error}
                                                                                                            </span>
                                                                                                        ) : null}
                                                                                                    </>
                                                                                                );
                                                                                            }}
                                                                                        </Field>
                                                                                    </FormControl>
                                                                                </Grid>
                                                                            </Grid>
                                                                            <span className="add-remove mb15">
                                                                                <div className="addmore">
                                                                                    {index === data.length - 1 && (
                                                                                        <Button
                                                                                            variant="outlined"
                                                                                            color="primary"
                                                                                            className="txt-capitalize"
                                                                                            onClick={() => {
                                                                                                push({
                                                                                                    name: '',
                                                                                                    hsn: '',
                                                                                                    tax: '',
                                                                                                    amount: '',
                                                                                                });
                                                                                                handleClick();
                                                                                            }}
                                                                                        >
                                                                                            Add More
                                                                                        </Button>
                                                                                    )}
                                                                                </div>
                                                                                <div className="removemore">
                                                                                    {data.length !== 1 && (
                                                                                        <Button
                                                                                            variant="outlined"
                                                                                            color="primary"
                                                                                            className="txt-capitalize"
                                                                                            onClick={() => {
                                                                                                remove(index);
                                                                                                handleRemove();
                                                                                            }}
                                                                                        >
                                                                                            Remove
                                                                                        </Button>
                                                                                    )}
                                                                                </div>
                                                                            </span>
                                                                        </Card>
                                                                    </Fragment>
                                                                );
                                                            })}
                                                        </>
                                                    );
                                                }}
                                            </FieldArray>

                                            <Grid container spacing={3} className="main-container">
                                                <Grid item xs={12} sm={12}>
                                                    <Grid xs={12} sm={6}>
                                                        <div>
                                                            <FormControl component="fieldset">
                                                                <RadioGroup
                                                                    defaultValue="IGST"
                                                                    // aria-label="aadhar"
                                                                    id="isIGST"
                                                                    name="isIGST"
                                                                    onChange={formik.handleChange}
                                                                    className="radio-option"
                                                                    value={formik.values.isIGST}
                                                                    onBlur={formik.handleBlur}
                                                                    onClick={(e) => handleGSTChange(e.target.value, formik)}
                                                                >
                                                                    <ul className={classes.inlineDisplay}>
                                                                        <li>
                                                                            <FormControlLabel
                                                                                value="IGST"
                                                                                control={<StyledRadio />}
                                                                                label="IGST"
                                                                            // name="govIDType"
                                                                            />
                                                                        </li>
                                                                        <li>
                                                                            <FormControlLabel
                                                                                value="CGST / SGST"
                                                                                control={<StyledRadio />}
                                                                                label="CGST / SGST"
                                                                            />
                                                                        </li>
                                                                    </ul>
                                                                </RadioGroup>
                                                            </FormControl>
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                {formik.values.isIGST === 'IGST' ? (
                                                    <Grid item xs={12} sm={6}>
                                                        <FormControl fullWidth>
                                                            <InputLabel className="lbl" htmlFor="Enter IGST %" shrink>
                                                                {' '}
                                                                Enter IGST %
                                                            </InputLabel>
                                                            <Field name="Igst">
                                                                {(fieldProps) => {
                                                                    const { field, meta } = fieldProps;
                                                                    return (
                                                                        <>
                                                                            <Input
                                                                                type="text"
                                                                                className="bottom "
                                                                                placeholder="Igst"
                                                                                {...field}
                                                                            />
                                                                            {meta.touched && meta.error ? (
                                                                                <span className="itec-validationError">{meta.error}</span>
                                                                            ) : null}
                                                                        </>
                                                                    );
                                                                }}
                                                            </Field>
                                                        </FormControl>
                                                    </Grid>
                                                ) : null}
                                                {formik.values.isIGST === 'CGST / SGST' ? (
                                                    <Grid item xs={12} sm={6}>
                                                        <FormControl fullWidth>
                                                            <InputLabel className="lbl" htmlFor="Enter CGST %" shrink>
                                                                {' '}
                                                                Enter CGST %
                                                            </InputLabel>
                                                            <Field name="Cgst">
                                                                {(fieldProps) => {
                                                                    const { field, meta } = fieldProps;
                                                                    return (
                                                                        <>
                                                                            <Input
                                                                                type="text"
                                                                                className="bottom "
                                                                                placeholder="Cgst"
                                                                                row="3"
                                                                                {...field}
                                                                            />
                                                                            {meta.touched && meta.error ? (
                                                                                <span className="itec-validationError">{meta.error}</span>
                                                                            ) : null}
                                                                        </>
                                                                    );
                                                                }}
                                                            </Field>
                                                        </FormControl>
                                                    </Grid>
                                                ) : null}
                                                {formik.values.isIGST === 'CGST / SGST' ? (
                                                    <Grid item xs={12} sm={6}>
                                                        <FormControl fullWidth>
                                                            <InputLabel className="lbl" htmlFor="Enter SGST %" shrink>
                                                                {' '}
                                                                Enter SGST %
                                                            </InputLabel>
                                                            <Field name="Sgst">
                                                                {(fieldProps) => {
                                                                    const { field, meta } = fieldProps;
                                                                    return (
                                                                        <>
                                                                            <Input
                                                                                type="text"
                                                                                className="bottom "
                                                                                placeholder="Sgst"
                                                                                {...field}
                                                                            />

                                                                            {meta.touched && meta.error ? (
                                                                                <span className="itec-validationError">{meta.error}</span>
                                                                            ) : null}
                                                                        </>
                                                                    );
                                                                }}
                                                            </Field>
                                                        </FormControl>
                                                    </Grid>
                                                ) : null}
                                                {/* <Grid item xs={12} sm={6}>
                                                    <FormControl fullWidth>
                                                        <InputLabel className="lbl" htmlFor="Description" shrink>
                                                            {' '}
                                                            Description
                                                        </InputLabel>
                                                        <Field name="description">
                                                            {(fieldProps) => {
                                                                const { field, meta } = fieldProps;
                                                                return (
                                                                    <>
                                                                        {showBtnLoader ? (
                                                                            <LoaderPopUp
                                                                                showLoader={showBtnLoader}
                                                                                handleClose={handleClose}
                                                                            />
                                                                        ) : null}
                                                                        <Input
                                                                            type="text"
                                                                            className="bottom "
                                                                            placeholder="Enter Description"
                                                                            {...field}
                                                                        />

                                                                       
                                                                    </>
                                                                );
                                                            }}
                                                        </Field>
                                                    </FormControl>
                                                </Grid> */}
                                                {/* <Grid item xs={12} sm={6} className="displayEngagement">
                                                    <FormControl fullWidth>
                                                        <InputLabel className="lbl" htmlFor="Enter Engagement Reference No" shrink>
                                                            
                                                           Engagement Reference No
                                                        </InputLabel>
                                                        <Field name="engagementRefNo">
                                                            {(fieldProps) => {
                                                                const { field, meta } = fieldProps;
                                                                return (
                                                                    <>
                                                                        <Input
                                                                            type="text"
                                                                            className="bottom "
                                                                            placeholder="Enter Engagement Reference No"
                                                                            {...field}
                                                                        />

                                                                        {meta.touched && meta.error ? (
                                                                            <span className="itec-validationError">{meta.error}</span>
                                                                        ) : null}
                                                                    </>
                                                                );
                                                            }}
                                                        </Field>
                                                    </FormControl>
                                                </Grid>
                                                */}
                                                <Grid item xs={12} sm={12}>
                                                    <div className="footer-button">
                                                        <ul style={{ margin: '0' }}>
                                                            <li>
                                                                <Button color="primary" type="submit" className="buttonnext txt-cap">
                                                                    Generate
                                                                </Button>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </div>
                                    </form>
                                </div>
                            );
                        }}
                    </Formik>
                </CardContent>
            </Card>
        </div>
    );
};

export default UpdateIndInvoice;
